import { useMutation } from '@tanstack/react-query';
import { getApiClient } from '../lib/apiClient';
import { VerifyKycResponse } from 'mh-client';
import { useLoadingModal } from './useLoadingModal';

export default function useStartKyc() {
    const client = getApiClient();

    const mutation = useMutation({
        mutationKey: ['kyc', 'verificationUrl'],
        mutationFn: async (): Promise<VerifyKycResponse> => {
            return await client.auth.getKycVerificationUrl();
        },
        onSuccess: data => {
            if (data instanceof VerifyKycResponse.Success) {
                window.location.href = data.verificationUrl;
            }
        },
    });

    useLoadingModal(mutation.isPending);

    return mutation;
}
